import React from 'react';
import { css } from 'glamor';
import PropTypes from 'prop-types';

export default class ActivityWithNoAvatar extends React.Component {
  constructor(props) {
    super(props);

    const opacity = this.props.showAvatar ? '1' : '0';

    const avatarAndRtlStyles = css({
      '& .activity .avatar': {
        opacity: opacity
      },
      '& .content p': {
        textAlign: this.props.language.indexOf('ar') >= 0 ? 'right' : '',
        direction: this.props.language.indexOf('ar') >= 0 ? 'rtl' : ''
      },
      '& .ac-input .ac-multichoiceInput .ac-choiceSetInput-compact': {
        direction: this.props.language.indexOf('ar') >= 0 ? 'rtl' : ''
      },
      '& .ac-input .ac-multichoiceInput .ac-choiceSetInput-compact::after': {
        content : this.props.language.indexOf('ar') >= 0 ? '\\200E‎' : ''
      },
      '& .ac-input .ac-multichoiceInput .ac-choiceSetInput-compact::before': {
        content : this.props.language.indexOf('ar') >= 0 ? '\\200E‎' : ''
      },
      '& .attachment .bubble': {
        textAlign: this.props.language.indexOf('ar') >= 0 ? 'right' : '',
        direction: this.props.language.indexOf('ar') >= 0 ? 'rtl' : ''
      },
      '& .ac-pushButton': {
        backgroundColor: this.props.webChatConfiguration.adaptiveCardPushButton.backgroundColor,
        borderStyle: this.props.webChatConfiguration.adaptiveCardPushButton.borderStyle, //'solid',
        borderColor: this.props.webChatConfiguration.adaptiveCardPushButton.borderColor ,// '#840084',
        borderRadius: this.props.webChatConfiguration.adaptiveCardPushButton.borderRadius ,//'10px',
        borderWidth: this.props.webChatConfiguration.adaptiveCardPushButton.borderWidth, //'1px',
        color: this.props.webChatConfiguration.adaptiveCardPushButton.color , //'#840084', // !important
        fontWeight: this.props.webChatConfiguration.adaptiveCardPushButton.fontWeight , //'500', // !important
        padding: this.props.webChatConfiguration.adaptiveCardPushButton.padding //'10px' 
      },
      '& .ac-pushButton:hover': {
        backgroundColor: this.props.webChatConfiguration.adaptiveCardPushButtonHover.backgroundColor, // '#840084', // !important
        borderStyle: this.props.webChatConfiguration.adaptiveCardPushButtonHover.borderStyle, //'solid',
        borderColor: this.props.webChatConfiguration.adaptiveCardPushButtonHover.borderColor, //'#840084',
        borderRadius:this.props.webChatConfiguration.adaptiveCardPushButtonHover.borderRadius, // '10px', //'8px',
        borderWidth: this.props.webChatConfiguration.adaptiveCardPushButtonHover.borderWidth, //'1px',
        color: this.props.webChatConfiguration.adaptiveCardPushButtonHover.color, //'#ffff', // !important
        fontWeight: this.props.webChatConfiguration.adaptiveCardPushButtonHover.fontWeight, //'600',
        padding: this.props.webChatConfiguration.adaptiveCardPushButtonHover.padding //'10px'
      }
    });

    this.state = { style: avatarAndRtlStyles };
  }
  render() {
    const { props } = this;
    return (
      <div className={this.state.style}>
        <div className="activity">{props.children}</div>
      </div>
    );
  }
}

ActivityWithNoAvatar.propTypes = {
  showAvatar: PropTypes.bool.isRequired
};
